import { makeActionCreator } from '../../config/store/utils'

import { getNotificationsConfig } from '../../services/config'

export const GET_NOTIFICATIONS_CONFIG = 'GET_NOTIFICATIONS_CONFIG'
export const GET_NOTIFICATIONS_CONFIG_SUCCESS = 'GET_NOTIFICATIONS_CONFIG_SUCCESS'
export const GET_NOTIFICATIONS_CONFIG_ERROR = 'GET_NOTIFICATIONS_CONFIG_ERROR'

export const onGetNotificationsConfig = makeActionCreator(GET_NOTIFICATIONS_CONFIG)
export const onGetNotificationsConfigSuccess = makeActionCreator(GET_NOTIFICATIONS_CONFIG_SUCCESS, 'payload')
export const onGetNotificationsConfigError = makeActionCreator(GET_NOTIFICATIONS_CONFIG_ERROR, 'payload')

export const onGetNotificationsConfigThunk = () => async dispatch => {
  dispatch(onGetNotificationsConfig())

  try {
    const { data } = await getNotificationsConfig()
    dispatch(onGetNotificationsConfigSuccess(data))
  } catch (err) {
    dispatch(onGetNotificationsConfigError(err))
  }
}
